<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-select v-model="searchForm.state" placeholder="请选择状态" class="handle-input mr10 mb10">
          <el-option
              v-for="item in stateList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="searchForm.projectId" placeholder="请选择所属项目" class="handle-input mr10 mb10">
          <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.name"
              :value="item.projectId">
          </el-option>
        </el-select>
        <el-input v-model="searchForm.name" placeholder="请输入区位" class="handle-input mr10 mb10"></el-input>
        <el-button type="primary" @click="searchEvent">搜索</el-button>
		<el-button type="default" @click="resetFilters">清空筛选条件</el-button>
        <el-button type="primary" @click="addLocationVisible = true,initLocationForm()">添加</el-button>
      </div>
      <el-table :data="locationList" border style="width: 100%;min-height: 550px;" ref="locationTable">
        <el-table-column label="编号" prop="locationId" min-width="200" align="center"></el-table-column>
        <el-table-column label="图片" min-width="150" align="center">
          <template slot-scope="scope">
            <el-image :src="scope.row.image" alt="" class="el-image" >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="名称" prop="name" min-width="200" align="center"></el-table-column>
        <el-table-column label="状态" prop="state" min-width="200" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.state == 1">生效中</el-tag>
            <el-tag type="info" v-if="scope.row.state == 0">未生效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="所属项目" prop="projectName" min-width="200" align="center"></el-table-column>
        <el-table-column label="排序" prop="sort" min-width="200" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="createDate" min-width="200" align="center"></el-table-column>
        <el-table-column label="更新时间" prop="updateDate" min-width="200" align="center"></el-table-column>
        <el-table-column label="操作" fixed="right" min-width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" class="table-el-button" @click="loadEditLocation(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" class="table-el-button" @click="deleteLocationConfirm(scope.row.locationId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            @current-change="changePage"
            background
            layout="total, prev, pager, next"
            :current-page="page.page"
            :page-size="page.size"
            :total="page.total">
        </el-pagination>
      </div>
    </div>

    <!--添加新区位-->
    <el-dialog title="添加区位" :visible.sync="addLocationVisible" width="600px">
      <el-form :model="locationForm" status-icon :rules="locationRules" ref="addLocationForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="图片" prop="image">
          <el-image :src="locationForm.image" alt="" class="el-image-mid" >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <el-upload
              class="upload-demo"
              :action="$baseURL + '/file/upload'"
              :headers="config"
              :before-upload="beforeImageUpload"
              :on-success="uploadSuccess"
              :show-file-list="false">
            <el-button slot="trigger" size="mini">更换</el-button><div style="color: red;">注：(尺寸:w750*h460;格式:jpg/png;大小<=200k)</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="locationForm.name"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="locationForm.state" placeholder="请选择状态">
            <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="locationForm.projectId" placeholder="请选择所属项目">
            <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.name"
                :value="item.projectId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-image :src="locationForm.icon" alt="" class="el-image" >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <el-upload
              class="upload-demo"
              :action="$baseURL + '/file/upload'"
              :headers="config"
              :before-upload="beforeImageUpload"
              :on-success="uploadIconSuccess"
              :show-file-list="false">
            <el-button slot="trigger" size="mini">更换</el-button><div style="color: red;">注：(尺寸:w50*h50;格式:jpg/png;大小<=100k)</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="位置1">
          <el-input v-model="locationForm.place1" placeholder="请输入位置" style="width: 40%;margin-right: 10px;"></el-input>
          <el-input v-model="locationForm.distance1" placeholder="请输入距离" style="width: 40%;"></el-input>
        </el-form-item>
        <el-form-item label="位置2">
          <el-input v-model="locationForm.place2" placeholder="请输入位置" style="width: 40%;margin-right: 10px;"></el-input>
          <el-input v-model="locationForm.distance2" placeholder="请输入距离" style="width: 40%;"></el-input>
        </el-form-item>
        <el-form-item label="位置3">
          <el-input v-model="locationForm.place3" placeholder="请输入位置" style="width: 40%;margin-right: 10px;"></el-input>
          <el-input v-model="locationForm.distance3" placeholder="请输入距离" style="width: 40%;"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="locationForm.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addLocationVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitLocationForm('addLocationForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑弹出框 -->
    <el-dialog title="区位编辑" :visible.sync="editLocationVisible" width="600px">
      <el-form :model="locationForm" status-icon :rules="locationRules" ref="editLocationForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="图片" prop="image">
          <el-image :src="locationForm.image" alt="" class="el-image-mid" >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <el-upload
              class="upload-demo"
              :action="$baseURL + '/file/upload'"
              :headers="config"
              :before-upload="beforeImageUpload"
              :on-success="uploadSuccess"
              :show-file-list="false">
            <el-button slot="trigger" size="mini">更换</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="locationForm.name"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="locationForm.state" placeholder="请选择状态">
            <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="projectId">
          <el-select v-model="locationForm.projectId" placeholder="请选择所属项目">
            <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.name"
                :value="item.projectId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-image :src="locationForm.icon" alt="" class="el-image" >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <el-upload
              class="upload-demo"
              :action="$baseURL + '/file/upload'"
              :headers="config"
              :before-upload="beforeImageUpload"
              :on-success="uploadIconSuccess"
              :show-file-list="false">
            <el-button slot="trigger" size="mini">更换</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="位置1">
          <el-input v-model="locationForm.place1" placeholder="请输入位置" style="width: 40%;margin-right: 10px;"></el-input>
          <el-input v-model="locationForm.distance1" placeholder="请输入距离" style="width: 40%;"></el-input>
        </el-form-item>
        <el-form-item label="位置2">
          <el-input v-model="locationForm.place2" placeholder="请输入位置" style="width: 40%;margin-right: 10px;"></el-input>
          <el-input v-model="locationForm.distance2" placeholder="请输入距离" style="width: 40%;"></el-input>
        </el-form-item>
        <el-form-item label="位置3">
          <el-input v-model="locationForm.place3" placeholder="请输入位置" style="width: 40%;margin-right: 10px;"></el-input>
          <el-input v-model="locationForm.distance3" placeholder="请输入距离" style="width: 40%;"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="locationForm.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editLocationVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitLocationForm('editLocationForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除提示框 -->
    <el-dialog title="提示" :visible.sync="delLocationVisible" width="300px">
      <div class="del-dialog-cnt" align="center">删除不可恢复，是否确定删除？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delLocationVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteLocation">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'location',
  data () {
    return {
      config: '',
      locationForm: {
        locationId: '',
        projectId: '',
        image: '',
        name: '',
        icon: '',
        place1: '',
        distance1: '',
        place2: '',
        distance2: '',
        place3: '',
        distance3: '',
        sort: 100,
        state: 1
      },
      locationList: [], // 记录区位信息，用于显示
      searchForm: {
        state: 1,
        projectId: '',
        name: ''
      }, // 搜索
      addLocationVisible: false, // 显示添加框
      editLocationVisible: false, // 显示编辑框
      delLocationVisible: false, // 显示删除框
      page: {
        page: 1,
        size: 10,
        total: 0
      },
      stateList: [
        {
          id: 1,
          name: '生效中'
        },
        {
          id: 0,
          name: '未生效'
        }
      ],
      projectList: [], // 项目列表
      locationRules: {
        projectId: [
          { required: true, message: '请选择所属项目', trigger: 'blur' },
        ],
        image: [
          { required: true, message: '请选择图片', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '图片链接长度在 2 到 255 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '姓名长度在 2 到 255 个字符',
            trigger: 'blur'
          }
        ],
        sort: [
          { required: true, message: '请输排序', trigger: 'blur' },
          { validator: this.checkInt, message: '排序为整数', trigger: 'blur' }
        ],
        state: [
          { required: true, message: '请选择状态', trigger: 'blur' },
        ]
      }
    }
  },
  created () {
    this.getLocationList(this.searchForm)
    this.getProjectList()
    this.config = {
      'Authorization': this.$store.state.token
    }
  },
  methods: {
    // 初始化区位表单数据
    initLocationForm() {
      this.locationForm = {
        locationId: '',
        projectId: '',
        image: '',
        name: '',
        icon: '',
        place1: '',
        distance1: '',
        place2: '',
        distance2: '',
        place3: '',
        distance3: '',
        sort: 100,
        state: 1
      }
    },
    // 切换页
    changePage (page) {
      this.page.page = page
      this.getLocationList(this.searchForm)
    },
    // 搜索事件
    searchEvent() {
      this.page.page = 1
      this.getLocationList(this.searchForm)
    },
	// 清空条件
	resetFilters() {
	      this.searchForm = {
	       state: '',
	       projectId: '',
	       name: ''
	      }
		  },
    // 区位片上传成功事件
    uploadSuccess(res) {
      this.locationForm.image = res.data
    },
    uploadIconSuccess(res) {
      this.locationForm.icon = res.data
    },
    // 获取项目列表
    async getProjectList() {
      const {data: res} = await this.$axios.get(`/project/list`)
      const arrData = []
      res.data.forEach(item => {
        const arr = {}
        arr.projectId = item.projectId
        arr.name = item.name
        arrData.push(arr)
      })
      this.projectList = arrData
    },
    // 获取区位列表
    async getLocationList (params) {
      Object.assign(params, params, this.page)
      const { data: res } = await this.$axios.get(`/location/page`, { params: params})
      const arrData = []
      res.data.records.forEach(item => {
        const arr = {}
        arr.locationId = item.locationId
        arr.projectId = item.projectId
        arr.projectName = item.projectName
        arr.image = item.image
        arr.name = item.name
        arr.icon = item.icon
        arr.place1 = item.place1
        arr.distance1 = item.distance1
        arr.place2 = item.place2
        arr.distance2 = item.distance2
        arr.place3 = item.place3
        arr.distance3 = item.distance3
        arr.sort = item.sort
        arr.state = item.state
        arr.createDate = item.createDate
        arr.updateDate = item.updateDate
        arrData.push(arr)
      })
      this.page.total = res.data.total
      this.locationList = arrData
    },
    // 提交表单
    submitLocationForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === 'addLocationForm') {
            this.addLocation()
          } else if (formName === 'editLocationForm') {
            this.editLocation()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 添加区位
    async addLocation () {
      const { data: res } = await this.$axios.post('/location', this.locationForm)
      if (res.code === 0) {
        this.$notify({title: res.msg, type: 'success'})
      } else {
        this.$notify({title: res.msg, type: 'error'})
      }
      this.addLocationVisible = false
      this.getLocationList(this.searchForm)
    },
    // 加载编辑区位
    loadEditLocation (row) {
      this.locationForm = {
        locationId: row.locationId,
        projectId: row.projectId,
        image: row.image,
        name: row.name,
        icon: row.icon,
        place1: row.place1,
        distance1: row.distance1,
        place2: row.place2,
        distance2: row.distance2,
        place3: row.place3,
        distance3: row.distance3,
        sort: row.sort,
        state: row.state
      }
      this.editLocationVisible = true
    },
    // 编辑区位
    async editLocation () {
      const { data: res } = await this.$axios.put('/location', this.locationForm)
      if (res.code === 0) {
        this.$notify({title: res.msg, type: 'success'})
      } else {
        this.$notify({title: res.msg, type: 'error'})
      }
      this.editLocationVisible = false
      this.getLocationList(this.searchForm)
    },
    deleteLocationConfirm (locationId) {
      this.locationForm.locationId = locationId
      this.delLocationVisible = true
    },
    // 删除区位
    async deleteLocation () {
      const { data: res } = await this.$axios.delete(`/location`, { params: { locationId: this.locationForm.locationId }})
      if (res.code === 0) {
        this.$notify({title: res.msg, type: 'success'})
      } else {
        this.$notify({title: res.msg, type: 'error'})
      }
      this.delLocationVisible = false
      this.getLocationList(this.searchForm)
    }
  }
}

</script>

<style lang="stylus" scoped>
.handle-box
  font-size 12px
.handle-input
  width 200px
  display inline-block
  margin-right 10px
.pagination
  display flex
  justify-content center
</style>
